<template>
  <tr class="shared-table-cells" :class="[...rowClass]" :style="{ ...styles }">
    <!-- Leftmost td for expand button -->
    <td class="flex items-center shared-table-cells-cell">
      <button @click="handleExpandRow(trData.id)">
        <VSvgIcon v-if="!expand" name="plus-circle" class="inline-block w-8 h-8" />
        <VSvgIcon v-else name="minus-circle" class="inline-block w-8 h-8" />
      </button>
    </td>

    <!-- tds mapped to the tColumns prop -->
    <td
      v-for="({ column }, index) in tColumns"
      :key="`referrals-table-data-${index}`"
      class="py-6 shared-table-cells-cell"
    >
      {{ trData[column] }}
    </td>

    <!-- td actions column -->
    <td v-if="withActionsCol" class="shared-table-cells-cell">
      <slot name="table-data-actions" v-bind="trData"> </slot>
    </td>

    <!-- nested table || loader -->
    <td
      v-if="!hasReferrals && loading"
      class="-mt-4 py-8 shared-table-cells-cell relative"
      :style="{ gridColumn: '1 / -1' }"
    >
      <VLoader classes="bg-transparent" :size="30" />
    </td>
    <td
      v-else-if="hasReferrals"
      class="-mt-4 shared-table-cells-cell"
      :class="[expand ? 'table-cell' : 'hidden']"
      :style="{ gridColumn: '1 / -1' }"
    >
      <TableReferrals
        :toolbarHeading="toolbarHeading"
        :withSearch="false"
        :withPagination="false"
        :withToolbar="true"
        :withDateRange="true"
        :tColumns="tNestedColumns"
        :tData="tNestedData"
        :isSingleColspan="handleSingleColspan"
        :getReferrals="getReferrals"
      >
        <template v-slot:[`table-data-${orderDetailsIndex(tNestedColumns)}`]="trData">
          <button
            class="mx-auto my-2 shared-table-cells-button round impersonate"
            @click="$emit('select', trData.items)"
          >
            <VSvgIcon name="content" class="w-8 h-8" />
          </button>
        </template>

        <template v-slot:[`table-data-${orderTotalIndex(tNestedColumns)}`]="trData">
          <span :class="[trData.amount < 0 ? 'text-ricoma-red-100' : 'text-ricoma-green-100']">
            {{ trData['order total'] }}
          </span>
        </template>

        <template v-slot:[`table-data-${totalBalanceIndex(tNestedColumns)}`]="trData">
          <span class="font-bold">{{ trData['total balance'] }}</span>
        </template>
      </TableReferrals>
    </td>
  </tr>
</template>

<script>
import { parseISO, isBefore } from 'date-fns';

import VLoader from '@/components/base/VLoader';
import VSvgIcon from '@/components/base/VSvgIcon';
import TableReferrals from '@/components/shared/table/TableReferrals';

/*
 * helper functions
 */
const findColumnIndex = (tHeading, tHeadings) => {
  return tHeadings.findIndex(({ column }) => column === tHeading);
};

export default {
  name: 'ReferralsTableRow',
  components: {
    VLoader,
    VSvgIcon,
    TableReferrals,
  },
  props: {
    toolbarHeading: {
      type: String,
      required: false,
      default: 'referrals',
    },
    trData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    tColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
    tNestedColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
    tNestedData: {
      type: Array,
      required: false,
      default: () => [],
    },
    referralsAll: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    getReferrals: {
      type: Function,
      required: true,
      default: () => {},
    },
    styles: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    withActionsCol: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      expand: false,
      loading: false,
    };
  },
  computed: {
    rowClass() {
      return this.expand
        ? 'bg-ricoma-gray-100 bg-ricoma-gray-300 hover:bg-ricoma-gray-300'
        : 'odd:bg-ricoma-gray-100 hover:bg-ricoma-gray-200';
    },
    // Check if data has been fetched by checking referrer's id as a key in the referralsAll object
    hasReferrals() {
      return Object.hasOwnProperty.call(this.referralsAll, this.trData.id);
    },
  },
  methods: {
    orderTotalIndex: tHeadings => findColumnIndex('order total', tHeadings),
    totalBalanceIndex: tHeadings => findColumnIndex('total balance', tHeadings),
    orderDetailsIndex: tHeadings => findColumnIndex('order details', tHeadings),
    isDateBeforeToday(date) {
      return isBefore(parseISO(date), parseISO(new Date().toISOString().slice(0, 10)));
    },
    handleSingleColspan({ is_last = false, overview_endDate = new Date(), type = '' }) {
      if (is_last && this.isDateBeforeToday(overview_endDate)) return true;
      if (type === 'PAYMENT') return true;
      return false;
    },
    async handleExpandRow() {
      if (!this.hasReferrals && !this.expand) {
        this.loading = true;
        await this.getReferrals();
        this.loading = false;
      }
      this.expand = !this.expand;
    },
  },
};
</script>
